// General
import React from 'react';

// Icons
import { FiDatabase, FiUsers, FiUser, FiInfo, FiExternalLink } from 'react-icons/fi';

// UI / Bootstrap
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

// Core Components / Charts
import BarChartComponent from '../core/BarChartComponent';
import TopDistrictsChart from '../core/TopDistrictsChart';
import DonutChart from '../core/DonutChart';

// Context
import { useDashboard } from '../data/dashboard/DashboardContext';

// Components
import NotificationIcons from '../components/NotificationIcon';


const Dashboard = () => {
  const { user, stats, serviceChartData, districtChartData } = useDashboard();

  const renderTooltip = (text) => <Tooltip>{text}</Tooltip>;

  const StatCard = ({ title, icon, count, tooltipText }) => (
    <div className="p-3 bg-white rounded border" style={{ minHeight: "114px" }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex align-items-center gap-2">
          <h6 className="mb-0">{title}</h6>
          <OverlayTrigger placement="right" overlay={renderTooltip(tooltipText)}>
            <FiInfo size={15} style={{ cursor: 'pointer', color: 'gray' }} />
          </OverlayTrigger>
        </div>
        <FiExternalLink size={20} style={{ cursor: 'pointer', color: 'black' }} />
      </div>
      <div className="d-flex align-items-center gap-3 mt-2" style={{ color: 'black', fontSize: '25px' }}>
        {icon}
        <span className='fw-bold'>{count}</span>
      </div>
    </div>
  );

  return (
    <div className='outletpage-container'>
      <div className="container-fluid mt-3 dashboard">

        {/* Başlık ve ikonlar */}
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div>
            <h3 style={{ fontWeight: 550, fontSize: 21 }}>Merhaba {user.name}</h3>
            <p style={{ color: '#6c757d', marginTop: '-5px' }}>Tüm taleplerinizi tek ekranda yönetin</p>

          </div>
          <NotificationIcons />
        </div>
                {/* Chart */}

        <div className="row g-3">
          <div className="col-12 col-md-12  col-lg-4">
            <div className="d-flex flex-column gap-3 mt-0">
              <StatCard title="Servisler" icon={<FiDatabase size={22} />} count={stats.totalServices} tooltipText="Toplam aktif servis sayısı" />
              <StatCard title="Personeller" icon={<FiUser size={22} />} count={stats.totalEmployees} tooltipText="Toplam personel sayısı" />
              <StatCard title="Müşteriler" icon={<FiUsers size={22} />} count={stats.totalCustomers} tooltipText="Toplam müşteri sayısı" />
            </div>
          </div>

          <div className="col-12 col-md-12 col-lg-8">
            <DonutChart />
          </div>
        </div>
        <div className="row g-3 mt-2">
          <div className="col-12 col-md-6">
            <BarChartComponent data={serviceChartData} title="Son 3 Gün Servisleri" height="350px" />
          </div>
          <div className="col-12 col-md-6">
            <TopDistrictsChart data={districtChartData} height="350px" />
          </div>
        </div>

      </div>
    </div>
  );
};

export default Dashboard;

